import React from 'react';

interface ActionButton {
  label: string;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
  loadingLabel?: string;
}

interface StepShellProps {
  stepNumber: 1 | 2 | 3 | 4;
  totalSteps?: number;
  title?: string;
  onBack?: () => void;
  primary?: ActionButton;
  secondary?: ActionButton;
  hideFooter?: boolean;
  contentClassName?: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
}

const StepShell: React.FC<StepShellProps> = ({
  stepNumber,
  totalSteps = 4,
  title = 'Device Setup',
  onBack,
  primary,
  secondary,
  hideFooter = false,
  contentClassName = '',
  headerRight,
  children,
}) => {
  const fillPct = Math.min(100, Math.round((stepNumber / totalSteps) * 100));

  return (
    <div className="dcf-overlay">
      <div className="dcf-page">
        <div className="dcf-header">
          {onBack && (
            <button
              type="button"
              onClick={onBack}
              className="dcf-header__back"
              aria-label="Back"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
              </svg>
            </button>
          )}
          <h2 className="dcf-header__title">{title}</h2>
          {headerRight && <div className="dcf-header__right">{headerRight}</div>}
        </div>

        <div className="dcf-progress">
          <div className="dcf-progress__bar">
            <div
              className="dcf-progress__fill"
              style={{ width: `${fillPct}%` }}
              aria-hidden="true"
            />
          </div>
        </div>

        <div className={`dcf-content ${contentClassName}`.trim()}>
          {children}
        </div>

        {!hideFooter && (primary || secondary) && (
          <div className="dcf-actions">
            {secondary && (
              <button
                type="button"
                onClick={secondary.onClick}
                className="dcf-button dcf-button--secondary"
                disabled={secondary.disabled || primary?.loading}
              >
                {secondary.label}
              </button>
            )}
            {primary && (
              <button
                type="button"
                onClick={primary.onClick}
                className="dcf-button dcf-button--primary"
                disabled={primary.disabled || primary.loading}
              >
                {primary.loading ? (
                  <>
                    <span className="dcf-spinner" aria-hidden="true" />
                    {primary.loadingLabel ?? 'Working…'}
                  </>
                ) : (
                  primary.label
                )}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default StepShell;
